import type {
  AgentExecutionDetail,
  AgentExecutionLogEntry
} from '~/api/agentLogs/types';
import { parseAgentInputMessageConfig } from '~/scenes/Build/scenes/FlowBuilder/components/Design/components/ComponentSettings/components/ComponentExecution/utils/logParser';

export type MappedTestCaseVariables = {
  name: string;
  variables: Record<string, string>;
  userMessage: string | null;
};

function extractUserMessage(logs: AgentExecutionLogEntry[]): string | null {
  const userMessage = logs
    .map(log => parseAgentInputMessageConfig(log.body))
    .find(config => config?.messageType === 'user');

  return userMessage?.content ?? null;
}

function collectVariableKeys(
  datasetVariableKeys: string[] | undefined
): string[] {
  const uniqueKeys = new Set(
    (datasetVariableKeys ?? []).filter(key => key.trim().length > 0)
  );

  if (uniqueKeys.size === 0) {
    uniqueKeys.add('message');
  }

  return Array.from(uniqueKeys);
}

export function mapExecutionToTestCaseVariables(
  detail: AgentExecutionDetail,
  options?: {
    datasetVariableKeys?: string[];
  }
): MappedTestCaseVariables {
  const variableKeys = collectVariableKeys(options?.datasetVariableKeys);

  return {
    name: '',
    variables: Object.fromEntries(variableKeys.map(key => [key, ''])),
    userMessage: extractUserMessage(detail.logs)
  };
}
